import styled from 'styled-components';
import { mq } from '@phishtool/ui';
export const StyledPreambleWrapper = styled.div.withConfig({ displayName: "StyledPreambleWrapper", componentId: "-vazkl9" }) `
  ${mq({
    width: ['100%', '40%'],
})}
`;
export const StyledTimelineWrapper = styled.div.withConfig({ displayName: "StyledTimelineWrapper", componentId: "-i9u0qp" }) `
  ${mq({
    width: ['100%', '50%'],
})}
`;
export const StyledTimelineWrapperInner = styled.div.withConfig({ displayName: "StyledTimelineWrapperInner", componentId: "-mc6a0e" }) `
  position: relative;
  padding-bottom: ${(props) => props.theme.spacers.medium};

  &::before {
    width: 2px;
    height: 100%;
    background-color: ${(props) => props.theme.colors.oxfordBlue};
    top: 0;
    left: 34px;
    content: '';
    position: absolute;
  }
`;
export const StyledDate = styled.h3.withConfig({ displayName: "StyledDate", componentId: "-aj0ioi" }) `
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.white};
  width: 70px;
  text-align: center;
  background-color: ${(props) => props.theme.colors.oxfordBlue};
  border-radius: 10px;
  padding-top: 1px;
  position: relative;
`;
export const StyledList = styled.ol.withConfig({ displayName: "StyledList", componentId: "-1nzd5j" }) `
  margin: 0 0 0 58px;
  padding: 0;
  list-style: none;
`;
export const StyledListItem = styled.li.withConfig({ displayName: "StyledListItem", componentId: "-g9617h" }) `
  font-size: 14px;
  padding-left: 22px;
  position: relative;
  margin: 0 0 ${(props) => props.theme.spacers.medium};

  &::before {
    width: 12px;
    height: 12px;
    border-radius: 6px;
    background-color: ${(props) => props.theme.colors.appleGreen};
    content: '';
    position: absolute;
    left: 0;
    top: 3px;
  }
`;
